export default function() {
  jQuery(document).on("nfFormReady", function(e, layoutView) {
    $(".nf-element").on("focus", function() {
      $(this)
        .parents(".field-wrap")
        .addClass("has--value");
    });

    $(".nf-element").on("focusout", function() {
      if (!$(this).val()) {
        $(this)
          .parents(".field-wrap")
          .removeClass("has--value");
      }
    });
  });
}
